import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faInfoCircle, faCheckDouble } from '@fortawesome/free-solid-svg-icons'

const BewdImmersive = (props) => {
  const {
    immersivePrice,
    personalizedPrice,
    numOfAssignments,
    numOfHours,
    numOfMentorshipMinutes,
  } = props;

  return (
    <>
      <div className="flex-grow-1">
        <ul className="list-unstyled pl-0 mb-0">
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />{immersivePrice.attributes.num_of_courses} Courses</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />Instant Ask and Chat</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />Q&A Database</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />Curriculum Written by Industry Experts</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />Assignments and Code Reviews by Mentors</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />{numOfAssignments} assignments and projects</li>
          <li><FontAwesomeIcon icon={faCheck} size="sm" className="mr-2" fixedWidth />{numOfHours} hours of learning</li>
        </ul>
      </div>
    </>
  );
}

export default BewdImmersive;
